export const GET_DISCOUNT_CODE_CONST = 'GET_DISCOUNT_CODE_CONST'
export const CLEAR_DISCOUNT = 'CLEAR_DISCOUNT'